import React, { PureComponent } from 'react';
import './article.component.style.css';
import { connect } from 'react-redux';
import { fetchCategories } from 'store/action/categories.action';
import { userLogin } from 'store/action/user.action';
import { addArticle, addArticleImage } from 'store/action/article.action';
import { updateArticle, fillArticle } from 'store/action/articles.action';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Button from 'component/button.component';
import Input from 'component/input.component';
import Icon from 'style/fonts/glyphmaps/icon.component';
import {
  ADD_ARTICLE_ERROR,
  ADD_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_SUCCESS_ERROR,
  UPDATE_ARTICLE_SUCCESS,
  FETCH_ARTICLE_SUCCESS,
  FETCH_ARTICLE_ERROR,
} from 'config/constants';
import CategoryList from '../category/category.list.component';
import { toast } from 'react-toastify';
import Select from '../../../component/dynamicSelect.component';
//import { useParams } from 'react-router-dom'; TODO: utilizar o match para pegar o parâmetro da url

class Article extends PureComponent {
  state = {
    id: '',
    description: '',
    title: '',
    summary: '',
    file: null,
    article_categories: [],
    status: 'PUBLISHED',
  };

  componentDidMount() {
    const [, , , edit, id] = this.props.location.pathname.split('/');
    const isEdition = Boolean(edit === 'edicao');
    this.props.fetchCategories();
    if (isEdition) {
      this._fillArticle(id);
    }
  }

  _handleSelectChange = selectedValue => {
    this.setState({
      status: selectedValue,
    });
  };

  _onChangeTitle = event => this.setState({ title: event.currentTarget.value });

  _onChangeSummary = event =>
    this.setState({ summary: event.currentTarget.value });

  _publishArticle = () => {
    const {
      description,
      title,
      summary,
      article_categories,
      file,
      status,
    } = this.state;
    const {
      user: { token },
      addArticle,
      addArticleImage,
    } = this.props;

    console.warn({ file });
    if (!file) {
      toast.error('Por favor, insira uma imagem para o artigo.');
      return;
    }

    addArticle(
      { description, title, summary, article_categories, status },
      token
    )
      .then(({ type, message, article }) => {
        if (type === ADD_ARTICLE_SUCCESS) {
          toast.success('Artigo enviado com sucesso!');
          this.setState({
            description: '',
            title: '',
            summary: '',
            file: null,
            article_categories: [],
            status: '',
          });
          const data = new FormData();
          data.append('file', file);
          addArticleImage(data, article.id, token);
        } else if (type === ADD_ARTICLE_ERROR) {
          toast.error(message);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        console.error(err);
      });
  };

  _onChangeCategories = (item, isSelected) => {
    const { article_categories } = this.state;
    const newArticle_categories = isSelected
      ? [...article_categories, item.id]
      : article_categories.filter(
          article_category => item.id !== article_category
        );

    this.setState({ article_categories: newArticle_categories }, () =>
      console.warn(this.state.article_categories)
    );
  };

  _onChangeArticleImage = event => {
    const file = event.currentTarget.files[0];

    const reader = new FileReader();
    reader.onload = () => {
      const fileRef = reader.result;
      this.setState({
        fileRef,
      });
    };

    reader.readAsDataURL(file);

    this.setState({ file });
  };

  _fillArticle = id => {
    fillArticle(id)
      .then(({ type, data }) => {
        if (type === FETCH_ARTICLE_SUCCESS) {
          this.setState({
            description: data.article.description,
            title: data.article.title,
            summary: data.article.summary,
            file: null,
            article_categories: data.categories,
            status: data.article.status,
          });
        } else if (type === FETCH_ARTICLE_ERROR) {
          toast.error(type);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        console.error(err);
      });
  };

  _modifyArticle = () => {
    const { description, title, summary } = this.state;
    const { updateArticle } = this.props;
    const [, , , , id] = this.props.location.pathname.split('/');

    updateArticle(id, {
      description,
      title,
      summary,
    })
      .then(({ type, message, article }) => {
        if (type === UPDATE_ARTICLE_SUCCESS) {
          toast.success('Artigo alterado com sucesso!');
          this.setState({
            description: '',
            title: '',
            summary: '',
            file: null,
            article_categories: [],
            status: '',
          });
        } else if (type === UPDATE_ARTICLE_SUCCESS_ERROR) {
          toast.error(message);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        console.error(err);
      });
  };

  render() {
    const { description, title, summary, fileRef, status } = this.state;
    const { categories } = this.props;
    const [, , , edit] = this.props.location.pathname.split('/');
    const isEdition = Boolean(edit === 'edicao');

    const arrayOfData = [
      {
        id: 'PUBLISHED',
        name: 'Publicar',
      },
      {
        id: 'UNPUBLISHED',
        name: 'Não Publicar',
      },
      {
        id: 'CANCELLED',
        name: 'Cancelar',
      },
    ];

    return (
      <div className="flex-column align-stretch">
        <div
          className="flex-row align-stretch justify-center self-align-center"
          style={{ padding: '30px 0' }}
        >
          <div
            style={{
              width: 800,
              marginLeft: 'auto',
              marginRight: 20,
            }}
            className="flex-column"
          >
            <CKEditor
              editor={ClassicEditor}
              data={description}
              onChange={(event, editor) => {
                const data = editor.getData();
                this.setState({ description: data });
              }}
            />
            {isEdition ? (
              <Button
                className="self-align-end"
                onClick={this._modifyArticle}
                text="Alterar"
                style={{ marginTop: 20, backgroundColor: '#185335' }}
              />
            ) : (
              <Button
                className="self-align-end"
                onClick={this._publishArticle}
                text="Publicar"
                style={{ marginTop: 20, backgroundColor: '#185335' }}
              />
            )}
          </div>
          <div className="flex-column align-stretch" style={{ width: 300 }}>
            <label
              id="upload-article-label"
              htmlFor="upload-article-image"
              className="flex-row align-center justify-center"
            >
              {!fileRef ? (
                <Icon fontFamily="AntDesign" name="pluscircleo" size={30} />
              ) : (
                <span
                  className="component-focus"
                  style={{ width: '100%', height: '100%' }}
                >
                  <img
                    src={fileRef}
                    style={{ width: '100%', height: '100%' }}
                    alt={'imagem para o artigo'}
                  />
                </span>
              )}
            </label>
            <input
              id="upload-article-image"
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={this._onChangeArticleImage}
            />
            <Input
              inputProps={{
                placeholder: 'Título',
                value: title,
                onChange: this._onChangeTitle,
              }}
            />
            <Input
              inputProps={{
                placeholder: 'Resumo',
                value: summary,
                onChange: this._onChangeSummary,
              }}
            />
            <CategoryList
              data={categories}
              onChange={this._onChangeCategories}
            />
            <Select
              arrayOfData={arrayOfData}
              onSelectChange={this._handleSelectChange}
              onload={status}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user, categories }) {
  return {
    user,
    categories,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: user => dispatch(userLogin(user)),
    fetchCategories: () => dispatch(fetchCategories()),
    addArticle: (article, token) => dispatch(addArticle(article, token)),
    addArticleImage: (data, id, token) =>
      dispatch(addArticleImage(data, id, token)),
    updateArticle: (id, article) => dispatch(updateArticle(id, article)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Article);
